import InputTextComp from "@components/UI/InputText/Index.jsx";
import { SaveTemplateEmail } from "@services/TemplateEmail/Index.jsx";
import { useForm } from 'react-hook-form';
import ButtonComp from "@components/UI/Button/Index.jsx";
import SweetAlert from "@components/Feedback/SweetAlert/Index.jsx";
import SelectOptionComp from "@components/UI/SelectOption/Index.jsx"
import { emailTypes } from "@enums/TemplatesEmail/Index.jsx";
import TextAreaComp from "@components/UI/TextArea/Index.jsx";
import ValidationsTemplateEmail from "@validations/TemplateEmail/Validations";
import { useState } from "react";
import TagsInfoModal from "@components/Modals/Admin/TagInfoModal/Index";
import { tagsPermitidasAPI } from "@enums/TemplatesEmail/Tags";
import TemplateEmailPreview from "@components/Modals/Admin/TemplateEmailPreview/Index";
import { Alert } from "antd";

const Create = ({ onSave }) => {

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue
    } = useForm({
        defaultValues: {
            nome: '',
            titulo: '',
            tipoEmail: null,
            conteudo: '',
        },
    });

    // Modal de tags
    const [isTagsModalVisible, setTagsModalVisible] = useState(false);
    const openTagsModal = () => setTagsModalVisible(true);
    const closeTagsModal = () => setTagsModalVisible(false);

    // Modal do template
    const [isTemplateModalVisible, setTemplateModalVisible] = useState(false);
    const openTemplateModal = () => setTemplateModalVisible(true);
    const closeTemplateModal = () => setTemplateModalVisible(false);


    const onSubmit = async (data) => {
        try {
            const { validateTags } = ValidationsTemplateEmail();

            // 1. Valida as tags no campo conteudo
            const tagsValidation = validateTags(data.conteudo);

            // 2. Se inválido, mostra erro e aborta
            if (!tagsValidation.valid) {
                const invalidTagsMessage = tagsValidation.invalidTags.length > 0
                    ? `As seguintes tags são inválidas: ${tagsValidation.invalidTags.join(', ')}`
                    : tagsValidation.message;

                SweetAlert.errorHTML('Erro de validação', invalidTagsMessage);
                return;
            }

            SweetAlert.loading();

            const payload = {
                nome: data.nome,
                titulo: data.titulo,
                tipoEmail: data.tipoEmail.value,
                conteudo: data.conteudo,
                flgStatus: true
            };

            const result = await SaveTemplateEmail(payload);

            SweetAlert.success('Cadastro Realizado!', 'Os dados foram salvos com sucesso.');

            onSave({ ...result });

            reset();

        } catch (error) {

            const errorMessage = error.parsed?.message || 'Não foi possível salvar o template de e-mail.';

            SweetAlert.errorHTML('Erro ao cadastrar', errorMessage);
            console.error(error);
        }
    };

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)} className="form">
                <div className="row py-3">

                    <div className="col-8 col-md-8">

                        <InputTextComp
                            label={"Nome Template"}
                            name={"nome"}
                            {...register('nome')}
                            placeholder={"Preencher com um nome para template"}
                            hoverMessage={"Preencher um um nome para template"}
                            required={true}
                        />

                        <InputTextComp
                            label={"Título E-mail"}
                            name={"titulo"}
                            {...register('titulo')}
                            placeholder={"Preencher com um título para o e-mail"}
                            hoverMessage={"Preencher com um título para o e-mail"}
                            maxLength={255}
                            required={true}
                        />

                        <SelectOptionComp
                            label={"Tipo E-mail"}
                            options={emailTypes}
                            value={watch("tipoEmail")}
                            onChange={(selected) => setValue("tipoEmail", selected)}
                            placeholder="Selecionar o tipo do e-mail"
                            hoverMessage="Os tipos de e-mail Envio da Resposta da Solicitação, Envio do Plano de Ação e Encerramento da Solicitação devem ser únicos."
                            required
                        />

                        <TextAreaComp
                            label={"Conteúdo"}
                            name={"conteudo"}
                            {...register('conteudo')}
                            placeholder={"Preencher com o conteúdo do e-mail"}
                            hoverMessage={"Preencher com o conteúdo do e-mail"}
                            //maxLength={555}
                            style={{ height: '10rem', resize: 'none' }}
                        />

                    </div>

                    <div className="col-8 col-md-8 d-flex justify-content-end mt-4">

                        <ButtonComp
                            title={"Ver Tags Disponíveis"}
                            classnameIcon={"fa-solid fa-circle-info"}
                            buttonColor={"#125578"}
                            type="button"
                            onClick={openTagsModal}
                        />

                        <ButtonComp
                            title={"Exemplo Template"}
                            classnameIcon={"fa-solid fa-circle-info"}
                            buttonColor={"#125578"}
                            type="button"
                            onClick={openTemplateModal}
                        />

                        <ButtonComp
                            title={"SALVAR"}
                            type={"submit"}
                            buttonColor={"#2b97be"}
                            classnameIcon={"fa-regular fa-floppy-disk"}
                            hoverMessage={"Botão para confirmar o cadastro"}
                        />

                    </div>

                </div>
            </form>


            {/* Modal de tags */}
            <TagsInfoModal
                visible={isTagsModalVisible}
                onClose={closeTagsModal}
                tags={tagsPermitidasAPI}
            />

            {/* Modal de Exemplo de Template */}
            <TemplateEmailPreview
                visible={isTemplateModalVisible}
                onClose={closeTemplateModal}
            />
        </div>
    );
}

export default Create;